import React from "react";
import ListPageLayout from "@layouts/ListPageLayout";
import {withRouter} from "react-router";

import GiveawayLogFilterForm from './GiveawayLogFilterForm';
import GiveawayLogListTable from './GiveawayLogListTable';

import giveaway_store, {filter_store} from '@store/Statistic/GiveawayLog/GiveawayLogStore';

import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

@withRouter
class GiveawayLogList extends React.PureComponent {
    constructor(props) {
        super();
        let id = props.location.id;
        let state = props.location.state;
        let username = props.location.username;
        this.updateData(state, id, username)
    }

    componentWillReceiveProps(props, nextContext) {
        let state = props.location.state;
        this.updateData(state);
    }

    updateData(state) {
        breadcrumb_store.resetByName('赠送列表', '赠送列表')
        if (state === undefined) {
            filter_store.resetAttr()
        } else {
            filter_store.setAttr(state)
        }
        giveaway_store.state = state;
    }


    render() {
        return (
            <ListPageLayout
                isCustomHeader
                header={<GiveawayLogFilterForm/>}
                list={<GiveawayLogListTable/>}
            />
        );
    }
}

export default GiveawayLogList;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/GiveawayLog/GiveawayLogList.jsx